import { useEffect, useState } from 'react';

// True from the first render the flag is true onwards, e.g. "this tab has been visited".
export function useLatchedFlag(flag: boolean): boolean {
    const [latched, setLatched] = useState(flag);

    useEffect(() => {
        if (flag) setLatched(true);
    }, [flag]);

    return latched || flag;
}
